import { IParametre } from '../../../../interfaces/IParametre/IParametre';

/** Hazır parametre seti tanımı */
export interface IHazirSet {
  ismi: string;
  simge: string;
  aciklama: string;
  kategori: string;
  parametreler: IParametre[];
}

/** Endüstriyel hazır parametre setleri */
export const HAZIR_PARAMETRE_SETLERI: IHazirSet[] = [
  // --- Üretim ---
  {
    ismi: 'Üretim',
    simge: 'tool',
    aciklama: 'Parça üretimi için temel parametreler',
    kategori: 'uretim',
    parametreler: [
      { turu: 'Yazı', ismi: 'parcaAdi', baslik: 'Parça Adı', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'parcaNo', baslik: 'Parça No', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'adet', baslik: 'Adet', degeri: null, ayarlar: { min: 1 }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'malzeme', baslik: 'Malzeme', degeri: null, ayarlar: { secenekler: ['Çelik', 'Alüminyum', 'Pirinç', 'Paslanmaz', 'Plastik', 'Bakır'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'XYZ', ismi: 'olcuXYZ', baslik: 'Ölçü (mm)', degeri: { x: null, y: null, z: null }, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'tolerans', baslik: 'Tolerans', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', degeri: null, ayarlar: { secenekler: ['Bekliyor', 'İşleniyor', 'Tamamlandı', 'Reddedildi'] }, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Finans ---
  {
    ismi: 'Finans',
    simge: 'dollar',
    aciklama: 'Mali kayıt parametreleri',
    kategori: 'finans',
    parametreler: [
      { turu: 'Para', ismi: 'tutar', baslik: 'Tutar', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'paraBirimi', baslik: 'Para Birimi', degeri: 'TRY', ayarlar: { secenekler: ['TRY', 'USD', 'EUR', 'GBP'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Tarih', ismi: 'tarih', baslik: 'Tarih', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', degeri: null, ayarlar: { secenekler: ['Gelir', 'Gider', 'Transfer', 'Yatırım'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Kişi Kaydı ---
  {
    ismi: 'Kişi Kaydı',
    simge: 'user',
    aciklama: 'Kişi/müşteri bilgileri',
    kategori: 'kisi',
    parametreler: [
      { turu: 'Yazı', ismi: 'ad', baslik: 'Ad', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'soyad', baslik: 'Soyad', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'email', baslik: 'E-posta', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Tarih', ismi: 'dogumTarihi', baslik: 'Doğum Tarihi', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Resim', ismi: 'fotograf', baslik: 'Fotoğraf', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı Alanı', ismi: 'adres', baslik: 'Adres', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Stok ---
  {
    ismi: 'Stok',
    simge: 'inbox',
    aciklama: 'Stok takip parametreleri',
    kategori: 'stok',
    parametreler: [
      { turu: 'Yazı', ismi: 'urunAdi', baslik: 'Ürün Adı', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'BarKod', ismi: 'barkod', baslik: 'Barkod', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'miktar', baslik: 'Miktar', degeri: null, ayarlar: { min: 0 }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Para', ismi: 'birimFiyat', baslik: 'Birim Fiyat', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'konum', baslik: 'Depo Konumu', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'minStok', baslik: 'Min. Stok', degeri: null, ayarlar: { min: 0 }, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Bakım ---
  {
    ismi: 'Bakım',
    simge: 'tool',
    aciklama: 'Bakım ve arıza takibi',
    kategori: 'bakim',
    parametreler: [
      { turu: 'Yazı', ismi: 'cihaz', baslik: 'Cihaz/Makine', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Tarih', ismi: 'sonBakim', baslik: 'Son Bakım Tarihi', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Tarih', ismi: 'sonrakiBakim', baslik: 'Sonraki Bakım', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', degeri: null, ayarlar: { secenekler: ['Çalışıyor', 'Bakımda', 'Arızalı', 'Devre Dışı'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'sorumlu', baslik: 'Sorumlu', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Bakım Notları', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Ölçüm ---
  {
    ismi: 'Ölçüm',
    simge: 'column-width',
    aciklama: 'Ölçüm ve kalite kontrol',
    kategori: 'olcum',
    parametreler: [
      { turu: 'Yazı', ismi: 'olcuAdi', baslik: 'Ölçü Adı', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'deger', baslik: 'Değer', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'birim', baslik: 'Birim', degeri: 'mm', ayarlar: { secenekler: ['mm', 'cm', 'm', 'inch', 'kg', 'g', 'lt', 'ml'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'toleransAlt', baslik: 'Tolerans Alt', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'toleransUst', baslik: 'Tolerans Üst', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Onay', ismi: 'uygun', baslik: 'Uygun mu?', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Görev ---
  {
    ismi: 'Görev',
    simge: 'carry-out',
    aciklama: 'Görev ve iş takibi',
    kategori: 'gorev',
    parametreler: [
      { turu: 'Yazı', ismi: 'baslik', baslik: 'Başlık', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'atanan', baslik: 'Atanan Kişi', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'oncelik', baslik: 'Öncelik', degeri: null, ayarlar: { secenekler: ['Düşük', 'Normal', 'Yüksek', 'Acil'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Tarih', ismi: 'bitisTarihi', baslik: 'Bitiş Tarihi', degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', degeri: 'Bekliyor', ayarlar: { secenekler: ['Bekliyor', 'Devam Ediyor', 'Tamamlandı', 'İptal'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'İlerleme Çubuğu', ismi: 'ilerleme', baslik: 'İlerleme', degeri: 0, ayarlar: { min: 0, maks: 100 }, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- Not ---
  {
    ismi: 'Not',
    simge: 'file-text',
    aciklama: 'Basit not/kayıt',
    kategori: 'not',
    parametreler: [
      { turu: 'Yazı', ismi: 'baslik', baslik: 'Başlık', degeri: null, ayarlar: { zorunlu: true }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı Alanı', ismi: 'icerik', baslik: 'İçerik', degeri: null, ayarlar: { satirSayisi: 5 }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', degeri: null, ayarlar: { secenekler: ['Genel', 'Toplantı', 'Fikir', 'Hatırlatma', 'Araştırma'] }, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- HMI Cihaz ---
  {
    ismi: 'HMI Cihaz',
    simge: 'desktop',
    aciklama: 'HMI paneli ve IoT cihaz ayarları',
    kategori: 'iot',
    parametreler: [
      { turu: 'Yazı', ismi: 'cihazIsmi', baslik: 'Cihaz İsmi', degeri: null, ayarlar: { zorunlu: true, solSimge: 'desktop' }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'cihazKimlik', baslik: 'Cihaz Kimliği', degeri: null, ayarlar: { sadeceOkunur: true, solSimge: 'key' }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'cihazTipi', baslik: 'Cihaz Tipi', degeri: 'hmi_pano', ayarlar: { secenekler: ['hmi_pano', 'kiosk', 'kart_okuyucu', 'gecis_kontrol'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'konum', baslik: 'Fiziksel Konum', degeri: null, ayarlar: { solSimge: 'environment' }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Yazı', ismi: 'sunucuAdresi', baslik: 'Sunucu Adresi', degeri: null, ayarlar: { zorunlu: true, solSimge: 'global' }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Anahtar', ismi: 'karanlikMod', baslik: 'Karanlık Mod', degeri: false, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Anahtar', ismi: 'olayLoglama', baslik: 'Olay Loglama', degeri: true, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
  // --- PDKS ---
  {
    ismi: 'PDKS',
    simge: 'clock-circle',
    aciklama: 'Personel devam kontrol sistemi',
    kategori: 'pdks',
    parametreler: [
      { turu: 'Anahtar', ismi: 'pdksAktif', baslik: 'PDKS Aktif', degeri: true, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Açılır Kutu', ismi: 'pdksMod', baslik: 'PDKS Modu', degeri: 'otomatik', ayarlar: { secenekler: ['otomatik', 'zamanli', 'manuel'] }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Sayı', ismi: 'kartBeklemeSuresi', baslik: 'Kart Bekleme Süresi (sn)', degeri: 15, ayarlar: { min: 3, maks: 60 }, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Anahtar', ismi: 'bilinmeyenKartUyari', baslik: 'Bilinmeyen Kart Uyarısı', degeri: true, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
      { turu: 'Anahtar', ismi: 'fotografCek', baslik: 'Giriş/Çıkışta Fotoğraf', degeri: false, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [] },
    ]
  },
];
